import * as Clipboard from "expo-clipboard";
import { useToast } from "./components/Toast";

export const useCopyToClipboard = () => {
	const { showToast } = useToast();

	const copyToClipboard = async (
		text: string,
		toastMessage = "Copied to clipboard",
	) => {
		await Clipboard.setStringAsync(text);
		showToast({
			message: toastMessage,
		});
	};

	return { copyToClipboard };
};
